import React from "react";
import ProductCard from "./ProductCard";
import { useNavigate } from "react-router-dom"; // Importar el hook useNavigate
import "./ProductList.css";

const ProductList = ({ products }) => {
  const navigate = useNavigate(); // Hook para la navegación

  const handleProductClick = (id) => {
    navigate(`/productos/${id}`); // Redirige a la página de detalles del producto
  };

  return (
    <div className="product-list">
      {products.map((product) => (
        <div
          key={product.id}
          onClick={() => handleProductClick(product.id)} // Navega al hacer clic
          style={{ cursor: "pointer" }} // Añadir un cursor tipo pointer
        >
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductList;
